import type { LocaleMessageBundle } from '../../types'

export const dayClosingReportMessages: LocaleMessageBundle = {
  vi: {
    'dayClosingReport.title': 'Báo cáo kết thúc ngày',
    'dayClosingReport.subtitle': 'Tổng hợp và đối chiếu toàn bộ các ca trong ngày kinh doanh.',
    'dayClosingReport.actions.preview': 'Tải bản xem trước',
    'dayClosingReport.actions.submit': 'Gửi báo cáo kết thúc ngày',
    'dayClosingReport.actions.approve': 'Duyệt',
    'dayClosingReport.actions.reject': 'Từ chối',
    'dayClosingReport.actions.reopen': 'Mở lại báo cáo ngày',
    'dayClosingReport.sections.sources': 'Các ca trong ngày',
    'dayClosingReport.sections.summary': 'Tổng hợp cuối ngày',
    'dayClosingReport.sections.saved': 'Báo cáo ngày đã lập',
    'dayClosingReport.fields.businessDate': 'Ngày kinh doanh',
    'dayClosingReport.fields.shiftCount': 'Số ca',
    'dayClosingReport.fields.actualClosingCash': 'Tiền mặt thực tế cuối ngày',
    'dayClosingReport.fields.note': 'Ghi chú/giải trình cuối ngày',
    'dayClosingReport.status.ready': 'Đủ điều kiện gửi',
    'dayClosingReport.status.notReady': 'Chưa đủ điều kiện',
    'dayClosingReport.warning.notReady': 'Tất cả phiếu ca phải được duyệt trước khi gửi báo cáo ngày.',
    'dayClosingReport.messages.submitted': 'Đã gửi báo cáo kết thúc ngày.',
    'dayClosingReport.empty': 'Chưa có phiếu ca trong ngày được chọn.',
  },
  en: {
    'dayClosingReport.title': 'Day closing report',
    'dayClosingReport.subtitle': 'Consolidate and reconcile every shift in the business day.',
    'dayClosingReport.actions.preview': 'Load preview',
    'dayClosingReport.actions.submit': 'Submit day closing report',
    'dayClosingReport.actions.approve': 'Approve',
    'dayClosingReport.actions.reject': 'Reject',
    'dayClosingReport.actions.reopen': 'Reopen day report',
    'dayClosingReport.sections.sources': 'Shifts in the day',
    'dayClosingReport.sections.summary': 'Day closing summary',
    'dayClosingReport.sections.saved': 'Submitted day reports',
    'dayClosingReport.fields.businessDate': 'Business date',
    'dayClosingReport.fields.shiftCount': 'Shift count',
    'dayClosingReport.fields.actualClosingCash': 'Actual end-of-day cash',
    'dayClosingReport.fields.note': 'End-of-day note/explanation',
    'dayClosingReport.status.ready': 'Ready to submit',
    'dayClosingReport.status.notReady': 'Not ready',
    'dayClosingReport.warning.notReady': 'Every shift report must be approved before the day report can be submitted.',
    'dayClosingReport.messages.submitted': 'Day closing report submitted.',
    'dayClosingReport.empty': 'No shift reports exist for the selected day.',
  },
}
